var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGrammar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.4,
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.318 9.036C10.149 10.154 9.421 10.934 8.212 10.934C6.73 10.934 5.82 9.699 5.82 8.009C5.82 6.319 6.743 5.11 8.16 5.11C9.226 5.11 9.759 5.656 10.084 6.514H11.436C11.124 4.928 9.993 3.888 8.16 3.888C6.08 3.888 4.455 5.552 4.455 8.009C4.455 10.466 6.067 12.13 8.212 12.13C10.162 12.13 11.605 10.713 11.605 8.503V7.879H8.576V9.036H10.318Z",
    strokeWidth: 0.1,
    fill: "currentColor",
    stroke: "#747474"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrammar);
export default __webpack_public_path__ + "static/media/grammar.efcd32fd3b5d4b7d020fc5c6e719f750.svg";
export { ForwardRef as ReactComponent };